import React from 'react';
import { FileUploader } from '../components/fileUploader/fileUploader';

export const FileForm: React.FC = () => {
    return <FileUploader />;
};
